import clsx from "clsx";
import { useAtom } from "jotai";
import { useCallback, useEffect, useState } from "react";

import { landerCplQuizAtom } from "../../../lander-cpl-quiz/lander-cpl-quiz.state";
import { GradientButton } from "../../../shared/components/fkl-gradient-button/fkl-gradient-button.component";
import {
  videoAdFinishedAtom,
  videoAdsQuestionCounterAtom,
  videoAdsQuizCurrentQuestionAtom,
  videoAdsQuizQuestionsAtom,
} from "../../video-ads-quiz.state";

export const VideoAdsQuizFooter: React.FC = () => {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const [videoAdsQuiz] = useAtom(videoAdsQuizQuestionsAtom);
  const [questionCounter, setQuestionCounter] = useAtom(
    videoAdsQuestionCounterAtom
  );

  const [videoAdFinished] = useAtom(videoAdFinishedAtom);
  const stepsPerQuestion = 1;
  const [showFooterMessage, setShowFooterMessage] = useState<boolean>(false);
  const [currentQuestion] = useAtom(videoAdsQuizCurrentQuestionAtom);

  const nextBtnFn = () => {
    if (isQuestionAnswered()) {
      if (videoAdsQuiz.length < landerCplQuiz.number_of_cosponsors) {
        setQuestionCounter(questionCounter + stepsPerQuestion);
      } else {
        window.theme.LanderCplQuizUtils.handleVideoAdsQuizNextSweepStep();
      }
    }
  };

  const isQuestionAnswered = useCallback(() => {
    return currentQuestion.answer;
  }, [currentQuestion.answer]);

  useEffect(() => {
    setShowFooterMessage(videoAdFinished);
  }, [videoAdFinished]);

  return (
    <div className="video__ads__quiz__footer">
      <GradientButton
        grayBackground={!isQuestionAnswered()}
        onClick={nextBtnFn}
      >
        Next
      </GradientButton>
      <div
        className={clsx(
          "video__ads__quiz__footer--confetti",
          showFooterMessage && "active-background"
        )}
      >
        {showFooterMessage && (
          <span
            className="video__ads__quiz__footer--message"
            data-testid="video__ads__quiz--footer"
          >
            {"You’ve been rewarded with +1 entry!"}
          </span>
        )}
      </div>
    </div>
  );
};
